export const VEHICLE_DICTIONARIES = {
  MAKE: { name: 'codeVehicleMakes', title: 'Make' },
  STYLE: { name: 'codeVehicleStyles', title: 'Style' },
};
